import { EventsBySportIdRequest } from "sb-bff-integration";
import { EntityType } from "sbtech-sports-data-api-contracts";
import { ActiveRequestsType } from "../../typings";
export const isEntityFromType = (entity, requestType, events) => {
    const entityType = getEntityType(entity, events);
    return entityType === getTypeByRequest(requestType);
};
const getEntityType = (entity, events) => {
    if (entity.entityType === EntityType.Event || entity.entityType === EntityType[EntityType.Event]) {
        return entity.type;
    }
    if (entity.entityType === EntityType.Market || entity.entityType === EntityType[EntityType.Market]) {
        const isOutrightMarket = events.find(e => e.id === entity.id) !== undefined;
        return isOutrightMarket
            ? EventsBySportIdRequest.EventTypesEnum.Outright
            : EventsBySportIdRequest.EventTypesEnum.Fixture;
    }
    return "";
};
const getTypeByRequest = (requestType) => {
    return requestType === ActiveRequestsType.outrights
        ? EventsBySportIdRequest.EventTypesEnum.Outright
        : EventsBySportIdRequest.EventTypesEnum.Fixture;
};
//# sourceMappingURL=isEntityFromType.js.map